module.exports = __webpack_public_path__ + "static/img/iconLuckycard.3e69325.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/iconLuckycard.svg
// module id = d6Kk
// module chunks = 0